import { useTranslation } from 'react-i18next';
import { Tab, Tabs, Tooltip, TabProps } from '@mui/material';

import { useIsDesktopDown } from 'hooks';
import { Icon, Button } from 'components';
import { ButtonProps } from 'components/button/types';

import { TabsNavProps } from './types';

export const TabsNav = ({
  data,
  value,
  onChange,
  onAddChild,
}: TabsNavProps) => {
  const isDesktopDown = useIsDesktopDown();
  const { t } = useTranslation(['familyInformation']);

  return (
    <div className="-mb-px lg:-mr-px lg:mb-0">
      <Tabs
        value={value}
        variant="scrollable"
        className="min-h-10"
        onChange={(_, value) => onChange(value)}
        orientation={isDesktopDown ? 'horizontal' : 'vertical'}
      >
        {data?.map((child) => (
          <Tab
            key={child.id}
            value={child.id}
            component={CustomTab}
            className="min-h-10 min-w-0 p-0"
            label={`${child.firstName} ${child.lastName}`}
            startIcon={
              child.isSetupRequired && (
                <Tooltip title="Information Missing">
                  <Icon.Info
                    width={16}
                    height={16}
                    className="[&_path]:fill-red-primary-primary"
                  />
                </Tooltip>
              )
            }
          />
        ))}

        <Tab
          value="create"
          onClick={onAddChild}
          label={t('addChild')}
          component={AddChildTab}
          className="min-h-10 min-w-0 p-0"
        />
      </Tabs>
    </div>
  );
};

const CustomTab = ({
  children,
  ...props
}: TabProps & Omit<ButtonProps, 'variant' | 'buttonClassName'>) => (
  <Button
    variant="text"
    buttonClassName="px-2 lg:justify-start min-w-0 lg:px-0"
    {...props}
  >
    {children}
  </Button>
);

const AddChildTab = ({
  onClick,
  children,
  ...props
}: TabProps & Omit<ButtonProps, 'variant' | 'buttonClassName'>) => (
  <Button
    variant="text"
    onClick={onClick}
    startIcon={<Icon.Plus />}
    buttonClassName="px-2 lg:justify-start min-w-0 lg:px-0"
    {...props}
  >
    {children}
  </Button>
);
